export * from './simple-date.pipe';
export * from './simple-date.module';
